import { DrawerStepper } from './DrawerStepper'
import { ApplicationPartyCategoryType, ApplicationPartyType } from '@/types/unlock'

export type MarriedOption = {
  label: string
  value: number
}

export type DirectoryOption = {
  label: string
  value: number | string
}

export type PartyOption = {
  label: string
  value: ApplicationPartyType
  category: ApplicationPartyCategoryType
  predefined?: boolean
}

export default DrawerStepper
